module.exports = __webpack_public_path__ + "img/94ad581.jpg";